import React, { useState } from 'react';
import c from './index.module.scss';
import Image from '@/src/shared/components/Image';

export default function VideoPlayer(props) {
  const { image, video } = props;
  const [play, setPlay] = useState(false);
  return (
    <div className={c.wrapper}>
      <div className={c.playButton}>
        {!play && (
          <div
            className={c.playWrapper}
            onClick={() => {
              setPlay(true);
            }}
          >
            <div className={c.background}>
              <Image
                className={c.play}
                src="/images/icons/play-white.svg"
                alt="Play button"
                width="14"
                height="14"
              />
            </div>
          </div>
        )}
      </div>
      {!play && (
        <div className={c.bg}>
          <Image src={image} fill alt="play" />
        </div>
      )}

      {play && (
        <video
          style={{ width: '100%' }}
          src={video}
          playsInline
          autoPlay
          loop
          controls
        />
      )}
    </div>
  );
}
